module.exports = __webpack_public_path__ + "static/media/btn_sales_summary.5e6d249b.png";